import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatDialogModule } from '@angular/material/dialog';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LeftToolbarComponent } from './dashboard/left-toolbar/left-toolbar.component';
import { OverviewComponent } from './dashboard/preview/overview/overview.component';
import { InvoicesComponent } from './dashboard/preview/invoices/invoices.component';
import { ConvertersComponent } from './dashboard/preview/converters/converters.component';
import { ConverterPageComponent } from './dashboard/preview/converters/converter-page/converter-page.component';
import { NewFolderComponent } from './dashboard/preview/invoices/new-folder/new-folder.component';
import { InvoiceFolderComponent } from './dashboard/preview/invoices/invoice-folder/invoice-folder.component';
import { RunProcessComponent } from './dashboard/preview/invoices/run-process/run-process.component';
import { ProfileComponent } from './dashboard/preview/profile/profile.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AccountingComponent } from './dashboard/preview/accounting/accounting.component';
import { NewTemplateComponent } from './dashboard/preview/accounting/new-template/new-template.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { HeaderComponent } from './dashboard/header/header.component';
import { ButtonComponent } from './dashboard/atoms/button/button.component';
import { SmallDialogComponent } from './dashboard/atoms/small-dialog/small-dialog.component';
import { AddClientButtonComponent } from './dashboard/atoms/add-client-button/add-client-button.component';
import { CreateFolderDialogComponent } from './dashboard/preview/dialogs/create-folder-dialog/create-folder-dialog.component';
import { ProgressDialogComponent } from './dashboard/atoms/progress-dialog/progress-dialog.component';
import { ClientUpdateDialogComponent } from './dashboard/atoms/client-update-dialog/client-update-dialog.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterPipe } from './pipes/filter.pipe';
import { TemplateRunDialogComponent } from './dashboard/atoms/template-run-dialog/template-run-dialog/template-run-dialog.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SifrarnikComponent } from './dashboard/preview/sifrarnik/sifrarnik.component';
import { SifrarnikTableComponent } from './dashboard/preview/sifrarnik/components/sifrarnik-table/sifrarnik-table.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SifrarnikAddDialogComponent } from './dashboard/preview/sifrarnik/components/sifrarnik-add-dialog/sifrarnik-add-dialog.component';
import { CustomTemplatesComponent } from './dashboard/preview/invoices/invoice-folder/custom-templates/custom-templates.component';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SifrarnikBulkImportComponent } from './dashboard/preview/sifrarnik/components/sifrarnik-bulk-import/sifrarnik-bulk-import.component';
import { UploaderComponent } from './dashboard/uploader/uploader.component';
import { FileUploadModule } from 'ng2-file-upload';
import { NgOtpInputModule } from 'ng-otp-input';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { SelectTemplateDialogComponent } from './dashboard/preview/dialogs/select-template-dialog/select-template-dialog.component';
import { TemplatesComponent } from './dashboard/preview/templates/templates.component';
import { AddTemplateDialogComponent } from './dashboard/preview/dialogs/add-template-dialog/add-template-dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SortPipe } from './pipes/sort.pipe';
import { InvoiceStatusLabelComponent } from './dashboard/invoice-status-label/invoice-status-label.component';
import { MatSortModule } from '@angular/material/sort';
import { TrialContactDialogComponent } from './dashboard/left-toolbar/trial-contact-dialog/trial-contact-dialog.component';
import { NoViewComponent } from './no-view/no-view.component';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatCardModule } from "@angular/material/card";
import { MatRippleModule } from "@angular/material/core";
import { FilterTableDataPipe } from './pipes/table.pipe';
import { OverscrollDirective } from './dashboard/directives/overscroll.directive';
import { ViberLoginComponent } from './viber-login/viber-login.component';
import { MatRadioModule } from '@angular/material/radio';
import { ResizableModule } from './dashboard/atoms/template-run-dialog/template-run-dialog/resizable.module';
import { InvoicePreviewComponent } from './dashboard/preview/invoices/invoice-preview/invoice-preview.component';
import { LoadingScreenComponent } from './loading-screen/loading-screen.component';
import { ZoomImageWheelService } from '@zoom-image/angular';
import { AssignDialogComponent } from './dashboard/atoms/assign-dialog/assign-dialog.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { EmailAvatarComponent } from './dashboard/atoms/email-avatar/email-avatar.component';
import { FiWeComponent } from './fi-we/fi-we.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { CreateInvoiceDialogComponent } from './dashboard/preview/dialogs/create-invoice-dialog/create-invoice-dialog.component';
import { EmployeesTableComponent, AddEmployeeDialogComponent } from './dashboard/preview/sifrarnik/components/employees-table/employees-table.component';
import { SalaryCalculationDialogComponent } from './dashboard/preview/dialogs/salary-calculation-dialog/salary-calculation-dialog.component';
import { FolderPasswordDialogComponent } from './dashboard/preview/dialogs/folder-password-dialog/folder-password-dialog.component';
import { SetFolderPasswordDialogComponent } from './dashboard/preview/dialogs/set-folder-password-dialog/set-folder-password-dialog.component';
import { ChartOfAccountsTableComponent } from './dashboard/preview/sifrarnik/components/chart-of-accounts-table/chart-of-accounts-table.component';
import { ChartOfAccountsAddDialogComponent } from './dashboard/preview/sifrarnik/components/chart-of-accounts-add-dialog/chart-of-accounts-add-dialog.component';
import { ChartOfAccountsBulkImportComponent } from './dashboard/preview/sifrarnik/components/chart-of-accounts-bulk-import/chart-of-accounts-bulk-import.component';
import { AccountSchemaTableComponent } from './dashboard/preview/sifrarnik/components/account-schema-table/account-schema-table.component';
import { AccountSchemaAddDialogComponent } from './dashboard/preview/sifrarnik/components/account-schema-add-dialog/account-schema-add-dialog.component';
import { AccountSchemaBulkImportComponent } from './dashboard/preview/sifrarnik/components/account-schema-bulk-import/account-schema-bulk-import.component';
import { OrganizationalUnitsTableComponent } from './dashboard/preview/sifrarnik/components/organizational-units-table/organizational-units-table.component';
import { OrganizationalUnitsAddDialogComponent } from './dashboard/preview/sifrarnik/components/organizational-units-add-dialog/organizational-units-add-dialog.component';
import { PriceListTableComponent } from './dashboard/preview/sifrarnik/components/price-list-table/price-list-table.component';
import { PriceListAddDialogComponent } from './dashboard/preview/sifrarnik/components/price-list-add-dialog/price-list-add-dialog.component';
import { PriceListBulkImportComponent } from './dashboard/preview/sifrarnik/components/price-list-bulk-import/price-list-bulk-import.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { BankPostingRuleDialogComponent } from './dashboard/preview/dialogs/bank-posting-rule-dialog/bank-posting-rule-dialog.component';
import { BankPostingRulesListDialogComponent } from './dashboard/preview/dialogs/bank-posting-rules-list-dialog/bank-posting-rules-list-dialog.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    LeftToolbarComponent,
    OverviewComponent,
    InvoicesComponent,
    ConvertersComponent,
    ConverterPageComponent,
    NewFolderComponent,
    InvoiceFolderComponent,
    RunProcessComponent,
    ProfileComponent,
    AccountingComponent,
    NewTemplateComponent,
    HeaderComponent,
    ButtonComponent,
    SmallDialogComponent,
    AddClientButtonComponent,
    CreateFolderDialogComponent,
    ProgressDialogComponent,
    ClientUpdateDialogComponent,
    FilterPipe,
    FilterTableDataPipe,
    TemplateRunDialogComponent,
    SifrarnikComponent,
    SifrarnikTableComponent,
    SifrarnikAddDialogComponent,
    CustomTemplatesComponent,
    SifrarnikBulkImportComponent,
    UploaderComponent,
    SelectTemplateDialogComponent,
    TemplatesComponent,
    AddTemplateDialogComponent,
    SortPipe,
    InvoiceStatusLabelComponent,
    TrialContactDialogComponent,
    NoViewComponent,
    OverscrollDirective,
    ViberLoginComponent,
    InvoicePreviewComponent,
    LoadingScreenComponent,
    AssignDialogComponent,
    EmailAvatarComponent,
    FiWeComponent,
    SafeUrlPipe,
    CreateInvoiceDialogComponent,
    EmployeesTableComponent,
    AddEmployeeDialogComponent,
    SalaryCalculationDialogComponent,
    FolderPasswordDialogComponent,
    SetFolderPasswordDialogComponent,
    ChartOfAccountsTableComponent,
    ChartOfAccountsAddDialogComponent,
    ChartOfAccountsBulkImportComponent,
    AccountSchemaTableComponent,
    AccountSchemaAddDialogComponent,
    AccountSchemaBulkImportComponent,
    OrganizationalUnitsTableComponent,
    OrganizationalUnitsAddDialogComponent,
    PriceListTableComponent,
    PriceListAddDialogComponent,
    PriceListBulkImportComponent,
    BankPostingRuleDialogComponent,
    BankPostingRulesListDialogComponent
  ],
  imports: [
    BrowserModule,
    ResizableModule,
    BrowserAnimationsModule,
    MatDialogModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatListModule,
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatMenuModule,
    MatDividerModule,
    MatIconModule,
    MatSnackBarModule,
    MatSidenavModule,
    MatProgressBarModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    CdkAccordionModule,
    HttpClientModule,
    NgxChartsModule,
    MatTooltipModule,
    NgxSkeletonLoaderModule,
    MatSlideToggleModule,
    MatSortModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MatTableModule,
    MatPaginatorModule,
    NgxImageZoomModule,
    MatBadgeModule,
    FileUploadModule,
    NgOtpInputModule,
    Angular2PromiseButtonModule.forRoot({
      spinnerTpl: '<span class="btn-spinner"><div class="spinner-loader"></div></span>',
    }),
    DragDropModule,
    MatCardModule,
    MatRippleModule,
    MatRadioModule,
    MatChipsModule,
    MatGridListModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  providers: [HttpClient, ZoomImageWheelService],
  bootstrap: [AppComponent],
})
export class AppModule { }
